import { attendeeFetchData } from "./index";

const notificationAPI = {
  fetch: (attendeeId) => attendeeFetchData(`/api/v2/attendees/${attendeeId}/system-notification`),
};

export default notificationAPI;
